import { LoggingStrategy } from '@/logger/strategies';
import { LogLevel, LogContext } from '@/logger';

export class CompositeLoggingStrategy implements LoggingStrategy {
  constructor(private readonly strategies: LoggingStrategy[]) {}

  log(level: LogLevel, message: string, context?: LogContext, error?: Error): void {
    const errors: unknown[] = [];
    this.strategies.forEach(strategy => {
      if (strategy.isEnabled(level)) {
        try {
          strategy.log(level, message, context, error);
        } catch (e) {
          errors.push(e);
        }
      }
    });
    if (errors?.length) {
      throw new Error(errors.join(' | '));
    }
  }

  isEnabled(level: LogLevel): boolean {
    return this.strategies.some(strategy => strategy.isEnabled(level));
  }
}
